import { isStoryEligible } from './extraRounds';

/** Fortælling 3 — fri fortælling med AI-feedback; samme unlock som Fortælling 1/2. */
export function isStory3Eligible(
  user: Parameters<typeof isStoryEligible>[0],
): boolean {
  return isStoryEligible(user);
}
